import {RouteContext} from "../../RouteContext";
import {ShoppingValueObject} from "../../../model/vo/content/ShoppingValueObject";
import {
    DetailPage,
    DetailPagePanelConstraint,
    DetailPagePanelIndicator,
    DetailPagePropertyIndicator
} from "../common/DetailPage";
import {ShoppingIO} from "../../../io/content/ShoppingIO";
import {ListPage} from "../common/ListPage";
import {ShoppingMainKeywordValueObject} from "../../../model/vo/content/ShoppingMainKeywordValueObject";
import {ShoppingMainKeywordIO} from "../../../io/content/ShoppingMainKeywordIO";
import {ShoppingPathJointValueObject} from "../../../model/vo/content/ShoppingPathJointValueObject";
import {ShoppingPathJointIO} from "../../../io/content/ShoppingPathJointIO";
import React from "react";
import {useStatePair} from "../../../type/States";
import {Switch} from "@fluentui/react-components";

const propertyDetail: DetailPagePropertyIndicator<ShoppingValueObject> = {}

type Panel = DetailPagePanelConstraint | 'ShoppingMainKeyword' | 'PathJoint';

const panelDescription: Record<Panel, string> = {
    Main: '기본',
    ShoppingMainKeyword: '메인키워드',
    PathJoint: '경로Joint'
};

export default function Detail(props: RouteContext) {
    // isActive 상태 관리
    const isActiveState = useStatePair<Map<bigint, boolean>>(new Map());

    const setActive = (id: bigint, isActive: boolean) => {
        const acc = new Map<bigint, boolean>(isActiveState.value);
        acc.set(id, isActive);
        isActiveState.setValue(acc);
    };

    const panelDetail: DetailPagePanelIndicator<ShoppingValueObject, Panel> = {
        ShoppingMainKeyword: (props: RouteContext, item: ShoppingValueObject): JSX.Element => (
            <ListPage
                {...props}
                key={'shopping-detail-list-page-shopping-modification'}
                description={ShoppingMainKeywordValueObject.description}
                excluded={new Set<keyof ShoppingMainKeywordValueObject>()}
                list={ShoppingMainKeywordIO.list}
                count={ShoppingMainKeywordIO.count}
                delete={ShoppingMainKeywordIO.delete}
                detailHref={item => `/admin/shoppings/mainKeywords/${item.id}`}
                editHref={item => `/admin/shoppings/mainKeywords/edit/${item.id}`}
                initialSearchConditions={[
                    {
                        name: 'shoppingId',
                        value: String(item.id),
                        condition: 'Equal'
                    },
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
            />
        ),
        PathJoint: (props: RouteContext, item: ShoppingValueObject): JSX.Element => (
            <ListPage
                {...props}
                description={ShoppingPathJointValueObject.description}
                list={ShoppingPathJointIO.list}
                count={ShoppingPathJointIO.count}
                postHref={'/admin/shoppings/pathJoints/post'}
                detailHref={item => `/admin/shoppings/pathJoints/${item.id}`}
                initialSearchConditions={[
                    {
                        name: 'shoppingId',
                        value: String(item.id),
                        condition: 'Equal'
                    },
                ]}
                itemValue={(item, key) => {
                    if (key === 'isActive') {
                        const present = isActiveState.value.get(item.id);
                        return (
                            <Switch
                                checked={present ?? item.isActive}
                                onChange={(ev, data) => {
                                    const id = Number(item.id.toString().split('n')[0]);

                                    fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/joints/${id}`, {
                                        method: 'PATCH',
                                        headers: {
                                            'Content-Type': 'application/json',
                                        },
                                        credentials: 'include',
                                        body: JSON.stringify({ wishState: data.checked }),
                                    })
                                        .then(async value => {
                                            const res = await value.json();
                                            console.log(res);

                                            if (!res) {
                                                return;
                                            }

                                            setActive(item.id, data.checked);
                                        });
                                }}
                            />
                        );
                    }
                    return undefined;
                }}
            />
        ),
    };

    return (
        <DetailPage
            {...props}
            propertyDescription={ShoppingValueObject.description}
            propertyDetail={propertyDetail}
            panelDescription={panelDescription}
            panelDetail={panelDetail}
            get={ShoppingIO.get}
        />
    );
}
